'use client';

import { useIntl } from 'react-intl';

import { Mail } from '@calm-web/icons';

import messages from '@/components/authForm/EmailAuthButton/messages';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAuth } from '@/context/auth/AuthProvider';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import { useSisu } from '../Provider';
import { Wrapper } from './styles';

export type EmailAuthButtonProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-email-auth-button"
	 * ```
	 */
	'data-testid'?: string;
};

export default function EmailAuthButton({
	'data-testid': testId = 'sisu-email-auth-button',
}: EmailAuthButtonProps) {
	const { authenticate } = useAuth();
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();
	const { backgroundColor, isMarketingOptInSelected } = useSisu();

	const isDarkBackground = backgroundColor !== 'gray0';

	const handleClick = () => {
		authenticate({
			authMethod: CalmAuthMethods.Email,
			marketingOptIn: isMarketingOptInSelected,
			loginHint: undefined,
		});
	};

	const buttonCta =
		authPrompt === 'login'
			? formatMessage(messages.emailSignInCta)
			: formatMessage(messages.emailContinueCta);

	return (
		<Wrapper
			$noPadding={false}
			backgroundColor={isDarkBackground ? 'white' : 'blue7'}
			borderColor={isDarkBackground ? 'white' : 'blue7'}
			textColor={isDarkBackground ? 'black' : 'white'}
			iconColor={isDarkBackground ? 'black' : undefined}
			contentAlignment="center"
			data-testid={testId}
			Icon={Mail}
			onPress={handleClick}
			role="link"
		>
			{buttonCta}
		</Wrapper>
	);
}
